<template>
  <div class="activityDetails align-center-main">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/navigator/parkCompleteSet' }">{{childName}}</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/navigator/parkCompleteSet/activity' }">{{ serviceMsg.serviceName }}</el-breadcrumb-item>
        <el-breadcrumb-item>详情</el-breadcrumb-item>
      </el-breadcrumb>

      <div class="m_t20" v-loading="loading">
        <div class="box2 boxShadow">
          <div class="state">{{(textList.joinEndTime,textList.beginTime,textList.endTime) | stateFilter(textList.joinEndTime,textList.beginTime,textList.endTime)}}</div>
          <img :src="textList.banner" alt="" class="in_b b_img" >
          <div class="content">
            <div class="textInfo">
              <div class="m_t30 titel "> {{textList.title}}</div>
              <!-- <p class="jiage m_t20" v-if="textList.price === 0"> 价格：免费</p>
              <p class="jiage" v-else> 价格：{{textList.price / 100 | PriceFilter}}元</p> -->
              <div class="wrap m_t14">
                <div class="textLeft">
                  <p>
                    <span><i class="iconfont  icon-shijian"></i> {{textList.beginTime | DateFilter('yyyy-MM-dd')}} 至 {{textList.endTime | DateFilter('yyyy-MM-dd')}}</span>
                    <!-- <span class="m_l40"><i class="iconfont  icon-renshu"></i> {{textList.showNum}} 人</span> -->
                  </p>
                  <p> <i class="iconfont  icon-dizhi"></i> {{textList.provinceName}}{{textList.cityName}}{{textList.countyName}}{{textList.address}}</p>
                  <div class="BMbtn mtop24" @click="signUp(textList.activityId)" v-if="formType === 1 || formType === 2 && textList.content.length !== 0">报名</div>
                </div>
              </div>

            </div>
            <SubmitSuccess v-if='submitSuccessFlag' @close='submitSuccessFlag = false;' class='submit-success' :tipsMsg='tips.tipsMsg'></SubmitSuccess>
          </div>
        </div>
        <div class="m_t20 article in_b boxShadow">
          <div v-html="textList.content" ref="text"></div>
          <div>
            <CustomForm :formObj="formInfo" @finishForm="submitForm" ref="customForm" v-if="formType === 2 && textList.content.length === 0"></CustomForm>
          </div>
        </div>
        <!-- <div class="m_t20 organizers in_b m_l20 boxShadow">
          <p class="til">主办方</p>
          <div class="m_t20 zb">
            <img :src="textList.sponsorLogo" alt="" class="in_b logo">
            <div class="in_b rig">
              <p class="mingcheng">{{textList.sponsorName}}</p>
              <p class="zhongz">{{textList.sponsorDesc}}</p>
            </div>
          </div>
        </div> -->
      </div>
      <MaskLogin v-show='showLogin' @close='showLogin = false;'></MaskLogin>

    <!-- 模态 -->
    <el-dialog :visible.sync="modalShow" title="活动表单" width="600px" top="10vh" center>
      <CustomForm :formObj="formInfo" @finishForm="submitForm" ref="customForm" v-if="formType === 2 && textList.content.length !== 0"></CustomForm>
    </el-dialog>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { jsTimestampFilter } from '@/utils/filters.js';
import deepcopy from '@/utils/deepcopy';

export default {
  data() {
    return{
      submitSuccessFlag: false,
      showLogin: false,
      loading: true,
      tips: {
        tipsMsg: '报名成功！等待企业与您联系。',
      },
      textList: {},
      formType: 0,
      formInfo: {},
      modalShow: false,
      serviceMsg: {},
      childName: '',
    }
  },
  methods:{
    // 报名
    signUp(id) {
      // if (this.token) {
      //   this.$router.push({ path: `/navigator/activityform/${id}` });  // 需要注释
      //   if (this.formType === 2) {
      //     this.$route.push({ path: `/navigator/activityform/${id}` });
      //   }else if(this.formType === 1) {
      //     this.submit();
      //   }
      // } else {
      //   this.showLogin = true;
      // }
      if (!this.token) {
        this.showLogin = true;
        return false;
      }
      if (this.formType === 2 && this.textList.content.length !== 0 && this.formInfo.itemList.length) {  // 富文本+表单
        this.modalShow = true;
      } else {
        // 直接预约接口
        this.submitForm();
      }
    },
    // 获取详情
    activityDetail() {
      this.loading = true;
      this.$http.post(`${this.URL_PREFIX}/app/get/activity/info/detail`,{
        activityId: this.$route.params.activityId,
        parkId: this.currentParkId,
      }, {
        headers: { token: this.token, },
      }).then((response) => {
        const res = response.data;
        this.loading = false;
        if (res.resCode === '10000') {
          if(Object.keys(res.resData).length != 0){
            this.textList = res.resData;
            this.formType = res.resData.formFlag;
            if (res.resData.formFlag === 2) {  // 如果不是纯文本
              this.formInfo.itemList = res.resData.formItemList.length ? deepcopy(res.resData.formItemList) : [];
            }
          }
        }
      });
    },
    closeModal() {  // 关闭模态
      this.modalShow = false;
      this.$refs.customForm.resetForm();
    },
    submitForm(content) {  // 提交
      this.loading = true;
      const orderBody = {
        parkId: this.currentParkId,
        activityId: this.$route.params.activityId,
      }
      if (this.formType === 2) {
        orderBody.content = content;
      }
       this.$http.post(`${this.URL_PREFIX}/app/added/activity/order`,orderBody, {
        headers: { token: this.token, }
      })
       .then((response) => {
        const res = response.data;
        this.submitSuccessFlag = true;
        this.loading = false;
        if(res.resCode === '10000') {
          if (this.formType === 2) {
            this.closeModal();
          }
          if (this.textList.checkFlag === 1) {
            this.tips.tipsMsg = '报名成功！';
          } else if (this.textList.checkFlag === 2){
            this.tips.tipsMsg = '报名成功！等待企业与您联系。';
          }
          if (this.textList.checkFlag === 1 && res.resData.orderFee && res.resData.orderFee !== 0) {
            setTimeout((val) => {
              this.$router.push({
                path: `/navigator/pay/paymentPage`,
                query: {
                  'orderId': res.resData.orderId,
                  'price': this.orderFee/100,
                  'orderType': 13,
                }
              });
            }, 1000);
          }
        }else{
          this.tips.tipsMsg = res.resDesc;
        }
      });
    },
  },
  updated() {
    const imgs = this.$refs.text.querySelectorAll('img');
    imgs.forEach((val) => {
      val.style.maxWidth = '100%';
    });
  },
  created() {
    this.activityDetail();
    if (this.parkServiceList.length) {
      const obj = this.parkServiceList.find((val) => {
        return val.serviceFlag === 6;
      });
      this.childName = obj.serviceName;
      this.serviceMsg = obj.children.find((val) => {
        return val.type === 13;
      });
    }
  },
  computed: {
    ...mapGetters(['currentParkId', 'token', 'parkServiceList']),
  },
}
</script>
<style lang="scss" scoped>
@import "~@scss";

.activityDetails{
  padding-bottom: 18px;
  background-color: #f6f6f6;
}
.box2{
  // height: 300px;
  display: flex;
  // margin-bottom: 20px;
  background-color: #fff;
}
.b_img{
  flex: 0 0 535px;
  width: 535px;
  height: 300px;
  border-radius: 4px 0 0 4px;
}
.content{
  flex: 1;
  box-sizing: border-box;
  padding: 0 0 0 40px;
  .textInfo{
    // display: flex;
    .wrap{
      display: flex;
    }
    .textLeft{
      width: 280px;
      flex: 1;
    }
    .address{
      width: 310px;
      text-align: left;
      word-wrap:break-word;
      // margin-top: 119px;
      margin-right: 20px;
      flex: 1;
    }
  }
  .titel{
    font-size: 26px;
    font-weight: 600;
    width: 549px;
  }
  .submit-success{
    right: 40%;
    bottom: 40%;
  }
  .mtop24 {
    margin-top: 24px;
  }
}
.iconfont{
  color: #999;
}
.BMbtn{
  width: 100px;
  height: 32px;
  border-radius: 7px;
  background-color: #D0021b;
  color: #fff;
  line-height: 32px;
  text-align: center;
  font-size: 16px;
  letter-spacing: 2px;
  cursor: pointer;
  margin-bottom: 10px;
}
.m_l40{
  margin-left: 40px;
}
.m_l20{
  margin-left: 20px;
}
.m_t30{
  margin-top: 30px;
}
.m_t20{
  margin-top: 20px;
}
.m_t10{
  margin-top: 10px;
}
.m_t14{
  margin-top: 14px;
}
.in_b{
  display: inline-block;
}
.state {
  background-color: #D92121;
  font-size: 16px;
  position: absolute;
  z-index: 999;
  margin-top: 16px;
  color: #fff;
  border-radius: 3px;
  padding: 2px 16px;
}
.jiage{
  color:#de2c32;
  font-size: 16px;
  font-weight: 600;
  margin-top: 10px;
}
.article{
  width: 100%;
  min-height: 200px;
  box-sizing: border-box;
  padding: 40px 40px 30px 40px;
  background-color: #fff;
  vertical-align: top;
  .til{
    font-size: 18px;
    font-weight: bold;
  }
}
.footbar{
  width: 788px;
  height: 60px;
  color: #999;
  border-top: 1px solid #f5f5f5;
  background-color: #fff;
  box-sizing: border-box;
  padding: 19px 40px;
  .cursor{
    cursor: pointer;
  }
}
.organizers{
  padding: 20px;
  width: 388px;
  background-color: #fff;
  box-sizing: border-box;
  .til{
    vertical-align: middle;
    font-size: 18px;
    font-weight: bold;
    height: 18px;
    line-height: 18px;
  }
  .zb{
    display: flex;
    align-items: center;
    .logo{
      width: 80px;
      height: 80px;
      border-radius: 50%;
    }
    .rig{
      margin-left: 20px;
      .mingcheng{
        font-size: 14px;
        font-weight: bold;
      }
      .zhongz{
        font-size: 12px;
        color: #666;
      }
    }
  }
}

</style>




// WEBPACK FOOTER //
// src/pages/navigator/parkCompleteSet/completeSetdetails/ActivityDetails.vue